<template>
  <div class="food-result">
    <mu-content-block class="blueHeader">
      <mu-flexbox>
        <mu-flexbox-item>
          {{title}}
        </mu-flexbox-item>
        <mu-flexbox-item align="right">
          <md-icon
            slot="default"
            style="cursor:pointer"
            @click.native="closeDialog('addFoodDialog')"
            v-text="'close'"
          >
          </md-icon>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block>
    <mu-paper style="position: relative; z-index: 99">
      <mu-list style="padding-top: 0; padding-bottom: 0;">
        <mu-list-item disableRipple :describeText="food.brand_name">
          <div slot="title">
            <span v-text="isLoading ? $t('message.loadingText') : food.food_name"></span>
          </div>
          <mu-icon v-if="mode === ''" @click.native="$emit('goBack', 's')" slot="left" value="chevron_left"></mu-icon>
        </mu-list-item>
      </mu-list>
    </mu-paper>
    <div class="scrollable-area">
      <mu-row gutter v-if="!isLoading">
        <mu-col width="100" :desktop="leftPaneWidth.desktop" :tablet="leftPaneWidth.tablet">
          <mu-content-block style="padding: 16px 24px;">
            <mu-row gutter>
              <mu-col
                width="50"
                :desktop="servingPickerWidth.servingInput.desktop"
                :tablet="servingPickerWidth.servingInput.tablet"
              >
                <mu-text-field
                  v-validate="'required|min_value:0|max_value:99'"
                  data-vv-name="serving_size"
                  :data-vv-as="$t('message.labelServingSize')"
                  :errorText="errors.first('serving_size')"
                  v-model.number="model.servings"
                  :min="0"
                  type="number"
                  :hintText="$t('message.labelMultiplier')"
                  :label="$t('message.labelServingSize')"
                  fullWidth
                ></mu-text-field>

              </mu-col>
              <mu-col width="50" :desktop="servingPickerWidth.servingSelector.desktop"
                      :tablet="servingPickerWidth.servingSelector.tablet">
                <mu-select-field
                  :scroller="scroller"
                  :maxHeight="248"
                  label=" "
                  v-model.number="model.serving_id"
                  fullWidth
                  autoWidth>
                  <mu-menu-item
                    v-for="(serving, index) in food.servings"
                    :key="'serving-' + index"
                    :value="serving.serving_id"
                    :title="serving.serving_description"
                  ></mu-menu-item>
                </mu-select-field>

              </mu-col>
            </mu-row>

            <mu-row style="margin-bottom: 8px;">
              <mu-col :desktop="servingPickerWidth.servingInput.desktop"
                      :tablet="servingPickerWidth.servingInput.tablet">
                <span>
                  <mu-flexbox align="center" style="height: 34px;">
                    <mu-flexbox-item style="font-weight: 500"
                                     v-text="$t('message.foodDiaryQuickPortionLabel')"></mu-flexbox-item>
                  </mu-flexbox>
                </span>
              </mu-col>
              <mu-col :desktop="servingPickerWidth.servingSelector.desktop"
                      :tablet="servingPickerWidth.servingSelector.tablet">
                 <span>
                  <mu-chip @click.native="setServingSize('0.25')">1/4</mu-chip>
                  <mu-chip @click.native="setServingSize('0.5')">1/2</mu-chip>
                  <mu-chip @click.native="setServingSize('0.75')">3/4</mu-chip>
                  <mu-chip @click.native="setServingSize('1')">1</mu-chip>
                </span>
              </mu-col>
            </mu-row>
            <mu-row gutter>
              <mu-col :desktop="servingPickerWidth.servingInput.desktop"
                      :tablet="servingPickerWidth.servingInput.tablet">
                <mu-time-picker
                  container="inline"
                  :label="$t('message.labelTime')"
                  mode="landscape"
                  fullWidth
                  v-model="timeModel.time"
                  :okLabel="$t('message.okText')"
                  :cancelLabel="$t('message.cancelText')"></mu-time-picker>
              </mu-col>
              <mu-col :desktop="servingPickerWidth.servingSelector.desktop"
                      :tablet="servingPickerWidth.servingSelector.tablet">
                <mu-date-picker
                  container="inline"
                  :label="$t('message.labelDate')"
                  :okLabel="$t('message.okText')"
                  :cancelLabel="$t('message.cancelText')"
                  :dateTimeFormat="dateFormat"
                  format="DD-MM-YYYY"
                  v-model="timeModel.date"
                  fullWidth></mu-date-picker>
              </mu-col>
            </mu-row>
          </mu-content-block>
        </mu-col>
        <mu-col width="100" desktop="50" tablet="50" class="rightPane" v-if="isNutritionPaneVisible">
          <mu-card-header
            class="removePadding"
            :subTitle=" model.servings + ' x ' + activeServingObject.serving_description"
          ></mu-card-header>
          <mu-divider></mu-divider>
          <mu-list class="oddEven">
            <mu-list-item
              disableRipple
              v-for="(value, key) in activeServingObject.nutrients"
              :key="'nutrient-'+ key"
              :title="$t(localizeNutrient(key))"
              :afterText="'' + rounded(value * model.servings) + getUnit(key)"
            >
            </mu-list-item>
          </mu-list>
        </mu-col>
      </mu-row>
    </div>
    <mu-card-actions class="card-actions" align="right" v-if="!isLoading">
      <mu-flat-button :label="$t('message.cancelText')" @click.native="closeDialog('addFoodDialog')"></mu-flat-button>
      <mu-raised-button
        :label="isSaving ? $t('message.savingText') : $t('message.saveText')"
        :disabled="isSaving"
        @click.native="saveFood()"
        secondary
      ></mu-raised-button>
    </mu-card-actions>
  </div>
</template>
<script>

  import dateFormat from '../../../helpers/DatePickerManager'
  import FoodApi from '../../../api/Food'
  import config from '../../../config'
  import NutrientLocalizerMixin from '../../../mixins/Localization/FoodNutrients/NutrientLocalizer'

  let numeral = require('numeral');

  const leftPaneWidth = {
    desktop: "50",
    tablet: "50"
  };

  const servingPickerWidth = {
    servingInput: {
      desktop: "40",
      tablet: "40"
    },
    servingSelector: {
      desktop: "60",
      tablet: "60"
    }
  };

  export default {
    mixins: [NutrientLocalizerMixin],
    name: 'fd-food-result-dialog',
    props: {
      inputDate: {
        type: String
      },
      title: {
        type: String,
        default: ""
      },
      foodId: {
        type: Number
      },
      mealTypeId: {
        type: Number
      },
      mode: {
        type: String,
        default: ""
      }
    },
    watch: {
      'model.serving_id': function () {
        let self = this, serving_id = self.model.serving_id;
        self.activeServingObject = self.food.servings.filter(function (item) {
          return item.serving_id === self.model.serving_id;
        })[0];
        self.computeHeightForRightPane();
      },
      'timeModel.time': function () {
        let self = this;
        let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
        self.model.date = moment(dateTime).format();
      },
      'timeModel.date': function () {
        let self = this;
        let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
        self.model.date = moment(dateTime).format();
      },
    },
    data() {
      return {
        maxDate: moment().format('DD-MM-YYYY'),
        modelDate: "",
        isSaving: false,
        isLoading: true,
        isNutritionPaneVisible: true,
        dateFormat: dateFormat,
        scroller: document.getElementsByClassName('main-content')[0],
        activeServingObject: {},
        food: {},
        leftPaneWidth: leftPaneWidth,
        servingPickerWidth: servingPickerWidth,
        model: {
          servings: 1,
          serving_id: 0
        },
        timeModel: {
          date: "",
          time: ""
        }
      }
    },
    mounted() {

      let self = this;
      let date = moment(self.inputDate, 'DD-MM-YYYY hh:mm a'), time = date.format('hh:mm a');
      let checkToday = moment();
      self.timeModel.time = time;
      self.timeModel.date = date.format('DD-MM-YYYY');
      FoodApi.getById(self.foodId)
        .then(function (response) {
          self.food = response.data.food;
          self.model.serving_id = self.food.servings[0].serving_id;
          self.isLoading = false;
          self.$nextTick(function () {
            self.initScrollFix();
            self.computeHeightForRightPane();
            $(self.$refs['dateInput']).val(moment(self.modelDate).format('YYYY-MM-DD'));
            $(self.$refs['timeInput']).val(moment(self.modelDate).format('hh:mm'))
          });
          self.$forceUpdate();
        })

    },
    methods: {
      dateChanged() {
        let self = this;
        let date = self.$refs['dateInput'].value;
        let time = self.$refs['timeInput'].value;
        let datetime = date + ' ' + time;
      },
      isDst(date) {
        if (moment(date).isDST()) {
          return true;
        }
        return false;
      },
      setServingSize(size) {
        let self = this;
        self.model.servings = size;
        self.$forceUpdate();
      },
      saveFood() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isSaving = true;
              let model = {
                date: self.model.date,
                meal_type_id: self.mealTypeId,
                foods: [
                  {
                    food_id: self.food.food_id,
                    food_name: self.food.food_name,
                    servings: self.model.servings,
                    serving_id: self.model.serving_id,
                    nutrients: self.activeServingObject.nutrients
                  }
                ]
              };
              FoodApi.addFoods(model)
                .then(function (response) {
                  self.isSaving = false;
                  self.$emit('foodAdded');
                  self.closeDialog('addFoodDialog');
                })
                .catch(function (error) {
                  self.isSaving = false;
                  self.closeDialog('addFoodDialog');
                })
            }
          })
      },
      toggleNutritionPane() {
        let self = this;
        self.isNutritionPaneVisible = !self.isNutritionPaneVisible;
        if (self.isNutritionPaneVisible !== true) {
          self.leftPaneWidth.tablet = "100";
          self.leftPaneWidth.desktop = "100";
          self.servingPickerWidth.servingInput.desktop = "20";
          self.servingPickerWidth.servingInput.tablet = "20";
          self.servingPickerWidth.servingSelector.desktop = "80";
          self.servingPickerWidth.servingSelector.tablet = "80";
        }
        else {
          self.leftPaneWidth.tablet = "50";
          self.leftPaneWidth.desktop = "50";
          self.servingPickerWidth.servingInput.desktop = "40";
          self.servingPickerWidth.servingInput.tablet = "40";
          self.servingPickerWidth.servingSelector.desktop = "60";
          self.servingPickerWidth.servingSelector.tablet = "60";
        }
        self.$nextTick(function () {
          self.computeHeightForRightPane();
        });
      },
      rounded(num) {
        let number = numeral(num.toFixed(2));
        return number.format('0,0.0')
      },
      humanize(str) {
        var frags = str.split('_');
        for (var i = 0; i < frags.length; i++) {
          frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
        }
        return frags.join(' ');
      },
      getUnit(key) {
        switch (key) {
          case 'calories':
            return 'kcal';
            break;
          case 'protein':
            return 'g';
            break;
          case 'carbohydrate':
            return 'g';
            break;
          case 'sugar':
            return 'g';
            break;
          case 'fat':
            return 'g';
            break;
          case 'saturated_fat':
            return 'g';
            break;
          case 'monounsaturated_fat':
            return 'g';
            break;
          case 'polyunsaturated_fat':
            return 'g';
            break;
          case 'cholesterol':
            return 'g';
            break;
          case 'fibre':
            return 'g';
            break;
          case 'sodium':
            return 'mg';
            break;
          case 'potassium':
            return 'mg';
            break;
        }
      },
      initScrollFix() {
        let headerHeight = $('.add-food-dialog .blueHeader').outerHeight(true);
        let displayBar = $('.food-result .mu-paper').outerHeight(true);
        let panelHeight = $('.add-food-dialog').outerHeight(true);
        let cardActionsHeight = $('.card-actions').outerHeight(true);
        let scrollHeight = panelHeight - (headerHeight + displayBar + cardActionsHeight);
        $('.food-dialog-container .scrollable-area').attr('style', 'height:' + scrollHeight + 'px;');
      },
      computeHeightForRightPane() {
        let scrollHeight = $('.food-dialog-container .scrollable-area').outerHeight(true);
        $('.rightPane').attr('style', 'height:' + scrollHeight + 'px;overflow:auto');
      },
      userDecidesTo(option) {
        this.$emit('choseToSearchWith', option);
      },
      closeDialog() {
        this.$emit('closeDialog')
      }
    }
  }
</script>
<style>
  .nativeInput {
    border: 0;
    font-weight: 400;
    font-size: 16px;
    border-bottom: 1px solid #bcbdc0;
  }

  .food-result .mu-item.show-left {
    padding-left: 58px;
  }

</style>



// WEBPACK FOOTER //
// FoodResultDialog.vue?73234ab8